exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dropdown[data-v-7445dd9c] {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}", "", {"version":3,"sources":["/var/www/html/brkt/src/components/BaseDropdown.vue"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,0BAAA;KAAA,uBAAA;MAAA,sBAAA;UAAA,kBAAA;CAAF","file":"BaseDropdown.vue?vue&type=style&index=0&id=7445dd9c&lang=scss&scoped=true","sourcesContent":["\n.dropdown {\n  cursor: pointer;\n  user-select: none;\n}\n"],"sourceRoot":""}]);

// exports
